export default {
  'global#home': 'Home',
  'global#maps': 'Mappe',
  'global#works': 'Opere',
  'global#date_human': 'Do MMMM YYYY',
  'global#layout_error_title': 'Spiacenti, si è verificato un errore',
  'global#layout_error_description':
    "Prova a ricaricare la pagina tra qualche istante e se il problema persiste contatta l'amministratore della piattaforma.",
  'global#facet_empty_text': 'No hay elementos disponibles',
  'global#facet_loading_text': 'Loading...',
  'readmore#label': 'Mostra tutto',
  'search#works_total': '<strong>{ total }</strong> Obras',
  'search#works_total_1': '<strong>{ total }</strong> Obra',
  'search#works_total_0': 'Sin Obra',
  'search#books_total': '<strong>{ total }</strong> Libri',
  'search#books_total_1': '<strong>{ total }</strong> Libro',
  'search#books_total_0': 'Nessun Libro',
  'search#witnesses_total': '<strong>{ total }</strong> Testimoni',
  'search#witnesses_total_1': '<strong>{ total }</strong> Testimone',
  'search#witnesses_total_0': 'Nessun Testimone',
  'search#placeholder_query': 'Buscar en títulos',
  'search#placeholder_query-content': 'Cerca nelle opere contenute',
  'search#header_authors': 'Autori',
  'search#header_keywords': 'Keywords',
  'search#header_works': 'Opere',
  'search#header_libraries': 'Biblioteca',
  'search#header_cities': 'Città',
  'search#header_dates': 'Date',
  'search#facets_title': 'Filtrar resultados',
  'search#filters_title': ' ',
  'search#sort_title': 'Ordenar',
  'search#sort_score': 'Ordine per pertinenza',
  'search#sort_asc': 'Orden alfabético (A→Z)',
  'search#sort_desc': 'Orden alfabético (Z→A)',
  'search#resultsamount': 'Resultados por página',
  'search#fallback_text':
    'No se han encontrado registros con estos parámetros de búsqueda.',
  'search#fallback_button': 'Cancelar la búsqueda',
  'search#ko_text':
    'No se han encontrado registros con estos parámetros de búsqueda.',
  'search#ko_button': 'Cancelar la búsqueda',
  'search#description_button': 'Info',
  'search#description_link': 'Ok, ho capito',
  'resource#authors': 'di',
  'resource#date': 'pubblicato il',
  'resource#time_to_read': 'lettura di',
  'resource#metadata': 'Metadati',
  'resource#metadata_size': 'Dimensioni',
  'search#header_genres': 'Genere',
  'search#header_language': 'Lingua',
  'search#date': 'data',
  'search#bibliographies_total':
    '<strong>{ total }</strong> riferimenti bibliografici',
  'search#bibliographies_total_1':
    '<strong>{ total }</strong> riferimento bibliografico',
  'search#bibliographies_total_0': 'Nessun riferimento bibliografico',
  'search#placeholder_authors': 'Cerca un autore',
  'search#title_bibliographies': 'Bibliografia',
  'search#biographies_total': '<strong>{ total }</strong> vite antiche',
  'search#biographies_total_1': '<strong>{ total }</strong> vita antica',
  'search#biographies_total_0': 'Nessuna vita antica',
  'search#title_biographies': 'Vite antiche',
  'search#iconographies_total': '<strong>{ total }</strong> iconografie',
  'search#iconographies_total_1': '<strong>{ total }</strong> icongrafia',
  'search#iconographies_total_0': 'Nessuna iconografia',
  'search#title_iconographies': 'Vite antiche',
  'search#tools_total': '<strong>{ total }</strong> materiali e strumenti',
  'search#tools_total_1': '<strong>{ total }</strong> materiale e strumento',
  'search#tools_total_0': 'Nessun materiale e strumento',
  'search#title_tools': 'Materiali e strumenti',
  'readmore#more': 'Leggi tutto',
  'readmore#less': 'Leggi meno',
  // Advanced search
  'advancedsearch#submit': 'Buscar',
  'advancedsearch#reset': 'Limpiar los campos',
  'advancedsearch#works_total': '<strong>{ total }</strong> resultados',
  'advancedsearch#works_total_1': '<strong>{ total }</strong> resultado',
  'advancedsearch#works_total_0': 'Sin resultados',
  'advancedsearch#filters_title': 'Filtri attivi',
  'search#results_number': 'Resultados por página',
  'advancedsearch#fulltext_text': 'Cerca nel portale (in tutti i campi)',
  'advancedsearch#bibliograficos': 'Datos bibliográficos',
  'advancedsearch#fecha': 'Fecha, cómputo de versos y estrofas',
  'advancedsearch#personajes': 'Personajes, espacio y tiempo',
  'advancedsearch#genero': 'Género y sinopsis',
  'advancedsearch#label_titulo': 'Título',
  'advancedsearch#label_autoria': 'Autoría',
  'advancedsearch#label_otros-autores': 'Otros Autores',
  'advancedsearch#label_parte': 'Parte',
  'advancedsearch#label_manuscrito': 'Manuscrito',
  'advancedsearch#label_biblioteca': 'Biblioteca',
  'advancedsearch#label_manuscrito-tipo': 'Tipo',
  'advancedsearch#label_otras-ediciones': 'Otras ediciones del siglo XVII y XVIII',
  'advancedsearch#label_otras-ediciones-colecciones': 'Colecciones',
  'advancedsearch#label_otras-ediciones-suelta': 'Suelta',
  'advancedsearch#label_colecciones-modernas': 'Colecciones modernas',
  'advancedsearch#label_ediciones-singulares': 'Ediciones singulares modernas',
  'advancedsearch#label_ediciones-singulares-consta': 'Ediciones singulares modernas',
  'advancedsearch#label_refundiciones-consta': 'Refundiciones, adaptaciones, arreglos, traducciones',
  'advancedsearch#label_refundiciones-lengua': 'Lengua',
  'advancedsearch#label_refundiciones-autor': 'Autor',
  'advancedsearch#label_bibliografia-url': 'Bibliografía secundaria',
  'advancedsearch#label_bibliografia-autor': 'Autor',
  'advancedsearch#label_bibliografia-notas': 'Notas',
  'advancedsearch#label_bibliografia-titulo': 'Título',
  'advancedsearch#label_fecha': 'Fecha',
  'advancedsearch#label_computo': 'Cómputo métrico',
  'advancedsearch#label_notas': 'Notas',
  'advancedsearch#label_espacio-dramaticos': 'Espacios dramáticos',
  'advancedsearch#label_espacio-dramaticos-toponimos': 'Topónimos',
  'advancedsearch#label_personajes-computables': 'Personajes computables',
  'advancedsearch#label_personajes-no-computables': 'Personajes no computables',
  'advancedsearch#label_universo-social': 'Universo social',
  'advancedsearch#label_ambientacion-cronologica': 'Ambientación cronológica',
  'advancedsearch#label_duracion-obra': 'Duración de la obra',
  'advancedsearch#label_duracion-comparacion': 'Comparación',
  'advancedsearch#label_duracion-intervalo': 'Entre',
  'advancedsearch#label_duracion-acto-I': 'Duración del I acto',
  'advancedsearch#label_duracion-entreacto-I-II': 'Duración del Entreacto I-II',
  'advancedsearch#label_duracion-acto-II': 'Duración del II acto',
  'advancedsearch#label_duracion-entreacto-II-III': 'Duración del Entreacto II-III',
  'advancedsearch#label_duracion-acto-III': 'Duración del III acto',
  'advancedsearch#label_propuesta-generica': 'Propuesta de adscripción genérica',
  'advancedsearch#label_propuesta-secundaria': 'Propuesta de adscripción genérica secundaria',
  'advancedsearch#label_motivos': 'Motivos',
  'advancedsearch#label_sinopsis': 'Sinopsis',
  'advancedsearch#info_otros-autores': 'Inserte el nombre del dramaturgo a buscar (en caso de comedia colaborada)',
  'advancedsearch#info_parte': 'Hemos indicado la <em>Parte de comedias</em> calderoniana en la que se publicó la comedia, aunque no fuese esta la primera edición impresa. Las demás ediciones impresas, incluidas las eventuales primeras ediciones anteriores a la <em>Parte</em> y las reediciones de Vera Tassis, se encuentran en el campo Otras ediciones del siglo XVII y XVIII.',
  'advancedsearch#info_manuscrito': 'Además de buscar el tipo de manuscrito (copia o autógrafo) con el desplegable dedicado, se puede introducir en el tercer campo de búsqueda el nombre de la Biblioteca (BNE, Biblioteca Histórica Municipal de Madrid, Institut del Teatre...).',
  'advancedsearch#info_otras-ediciones': 'Damos cuenta aquí de todas las ediciones impresas, en colecciones o en sueltas, tanto las reseñadas por el <em>Manual bibliográfico calderoniano</em> de K. y R. Reichenberger, como las que se han descubierto después y que han sido reseñadas en las ediciones más recientes. En el campo libre de búsqueda se pueden introducir términos como el nombre del impresor, la ciudad, el año.',
  'advancedsearch#info_bibliografia-url': 'En el campo Autor, para restringir la búsqueda, pueden introducirse los dos apellidos si procede. Si el título del artículo o monografía reseñados es demasiado genérico, puede que se hayan indicado más detalles (títulos de obras analizadas, temas...) en el campo Notas, adonde se podrán buscar.',
  'advancedsearch#info_fecha': 'En la búsqueda se debe introducir un año; el sistema buscará todas las obras cuya datación supuesta incluye, en el intervalo propuesto por la crítica y recogido en la ficha (campos Fecha inicial / Fecha final), dicho año.',
  'advancedsearch#info_computo': 'Elegir en el desplegable la forma métrica a buscar. Toda vez que hay pasajes cantados/musicados, estos han sido reseñados dos veces: una como tales, otra según la forma métrica propia. Los romancillos y romances endecha aparecen bajo el rótulo de romance, con su asonancia.',
  'advancedsearch#info_notas': 'Se pueden buscar aquí palabras y términos métricos consignados en los campos de Notas, para afinar la búsqueda realizada con el desplegable (por ej., glosa, copla, letrilla, cantar, etc.).',
  'advancedsearch#info_espacio-dramaticos': 'En el campo “Espacios dramáticos” se podrán buscar las ambientaciones genéricas (monte, campo, jardín, etc.); en el campo “Topónimos”, el nombre concreto del lugar en el que se ambienta la acción (Madrid, Hungría, Polonia, etc.). La búsqueda puede hacerse en los dos campos a la vez: por ejemplo, buscando <em>monte</em> en el primer campo y <em>Mantua</em> en el segundo, el resultado será <em>El acaso y el error.</em>',
  'advancedsearch#info_propuesta-generica': `En el desplegable, se puede elegir entre unas opciones de adscripción genérica jerarquizadas, que prevén tres macrogéneros: Comedia, Drama, Tragedia. Puesto que la tragedia siempre es clasificable asimismo como drama, hemos previsto un campo que dé cuenta de la adscripción genérica secundaria. El mapa taxonómico que hemos utilizado es el siguiente:<br>
  <div class='mr-tooltip-cols'>
  <ul>
    <li>COMEDIA</li>
    <ul>
      <li>espacio-tiempo concreto, doméstico y contemporáneo</li>
      <ul>
        <li>de capa y espada</li>
      </ul>
      <li>espacio-tiempo vago, remoto y/o fantástico</li>
      <ul>
        <li>palatina</li>
        <li>mitológica</li>
        <li>novelesca</li>
        <ul>
          <li>caballeresca</li>
          <li>bizantina</li>
        </ul>
        <li>burlesca</li>
      </ul>
    </ul>
  </ul>
  <ul>
    <li>DRAMA</li>
    <ul>
      <li>historial</li>
      <ul>
        <li>profano</li>
        <ul>
          <li>Antigüedad</li>
          <li>Edad Media</li>
          <li>Siglo XVI</li>
          <li>Contemporánea (siglo XVII)</li>
        </ul>
      </ul>
      <li>religioso</li>
      <ul>
        <li></li>
        <li></li>
      </ul>
      <li>imaginario</li>
      <ul>
        <li>doméstico</li>
        <li>palatino</li>
        <li>mitológico</li>
        <li>novelesco</li>
        <ul>
          <li>caballeresco</li>
          <li>bizantino</li>
        </ul>
      </ul>
    </ul>
  </ul>
  </div>`,
  'advancedsearch#info_motivos': `Basta con empezar a escribir una palabra en el campo de búsqueda, y una función de <em>autocomplete</em> mostrará los motivos que se han reseñado que contengan esa palabra. Para una lista completa de los motivos reseñados pulsar <a href='https://admin.calderondigital.tespasiglodeoro.it/wp-content/uploads/2026/03/Lista-de-motivos_3-11-2025.pdf' target='_blank'>aquí</a>. Para las premisas metodológicas que nos han guiado, ver el artículo de Fausta Antonucci, <a href='http://admin.calderondigital.tespasiglodeoro.it/wp-content/uploads/2026/04/antonucci_bullettin_2018.pdf' target='_blank'>“Una nueva herramienta para el estudio del teatro clásico español: <em>Calderón Digital. Base de datos, argumentos y motivos del teatro de Calderón</em>”</a>, <em>Bulletin of the Comediantes</em>, 70:1, 2018, pp. 79-95.`,
  'advancedsearch#info_sinopsis': `Puede buscarse cualquier palabra para implementar la búsqueda que se haya realizado en el campo Motivos. En la sinopsis, se da cuenta de los deslindes métricos y dramáticos (momentos de tablado vacío que implican cambio de cuadro, marcados con línea continua; momentos de tablado vacío que no implican cambio de cuadro, marcados con línea discontinua), de los cambios de espacio dramático y de tiempo dramático. Para más detalles, ver el artículo de Fausta Antonucci, <a href='http://admin.calderondigital.tespasiglodeoro.it/wp-content/uploads/2026/04/antonucci_bullettin_2018.pdf' target='_blank'>“Una nueva herramienta para el estudio del teatro clásico español: <em>Calderón Digital. Base de datos, argumentos y motivos del teatro de Calderón</em>”</a>, <em>Bulletin of the Comediantes</em>, 70:1, 2018, pp. 79-95.`,
  'advancedsearch#message': 'Elegir en el desplegable para ver los campos de cada sección. En los campos de texto, se podrá efectuar una búsqueda exacta utilizando las comillas altas (por ejemplo, buscando “Fernández Rodríguez” o “se esconde” solo saldrán las porciones de texto indicadas); una búsqueda con asterisco dará como resultados todas las ocurrencias de la palabra o parte de la palabra buscada (por ejemplo, buscando Fernández* saldrán todos los autores que se llaman Fernández Rodríguez, Fernández Mosquera, etc.); la búsqueda normal, sin asterisco ni comillas, dará como resultados todas las fichas en las que aparece cualquiera de las palabras buscadas (por ejemplo, buscando Fernández Rodríguez saldrán tanto Fernández Mosquera como Rodríguez Cuadros).',
  // TABS
  'tabs#record_bibliograficos': 'DATOS BIBLIOGRÁFICOS',
  'tabs#record_fecha': 'FECHA, CÓMPUTO DE VERSOS Y ESTROFAS',
  'tabs#record_personajes': 'PERSONAJES, ESPACIO Y TIEMPO',
  'tabs#record_genero': 'GÉNERO Y SINOPSIS',
  // Search opere
  'search#redirect_link': ' Búsqueda avanzada',
  'search#header_autoria': 'Autoría',
  'search#header_refundiciones': 'Refundiciones y traducciones',
  'search#header_universo': 'Universo social',
  'search#header_duracion': 'Duración de la obra',
};
